import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "workbook-templates",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      import(
        /* webpackChunkName: "admin-academicSetup" */ "./modules/WorkbookTemplatesModule"
      ),
    ])
      .then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "workbook-templates",
          reducer,
        });
        return component;
      })
      .catch(err => {
        return err;
      })
  ),
});
